import { FC } from 'react';
import { Box, Typography } from '@mui/material';
import { css } from '@emotion/react';

import { styles } from './styles';

import type { SectionProps } from './types';

export const Section: FC<SectionProps> = ({ header, children, style, withHeaderStipe = true }) => (
    <Box css={css(styles.container, style)}>
        <Typography css={css(styles.header, withHeaderStipe && styles.headerStripe)} variant="h2">
            {header}
        </Typography>
        {children}
    </Box>
);
